import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import { FiSettings } from "react-icons/fi";

export default function QuickActionsCard() {
  const actions = [
    ["Restart HRMS Services", "/assets/img/icons/action-icon-1.svg"],
    ["Sync Biometric", "/assets/img/icons/action-icon-2.svg"],
    ["Clear System Cache", "/assets/img/icons/action-icon-3.svg"],
    ["Schedule Maintenance", "/assets/img/icons/action-icon-4.svg"],
    ["Stop Background Jobs", "/assets/img/icons/action-icon-5.svg"],
    ["Re-run Payroll Job", "/assets/img/icons/action-icon-6.svg"],
  ];

  return (
    <Card className="h-100"
      style={{
        borderRadius: "5px",
        border: "2px solid #e5e7eb",
        position: "relative",
      }}
    >
      {/* TOP RIGHT ORANGE ICON */}
      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          background: "#f2540b",
          borderRadius: "6px",
          padding: "6px",
          color: "#fff",
        }}
      >
        <FiSettings size={14} />
      </div>

      <Card.Body style={{ padding: "20px" }}>
        {/* TITLE */}
        <strong
          style={{
            fontWeight: "650",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "20px",
            fontSize:"17"
          }}
        >
          <span 
            style={{
              width: "10px",
              height: "10px",
              border: "2px solid #f2540b",
              borderRadius: "3px",
              display: "inline-block",
              
            }}
          >
            
          </span>
          Quick IT Actions
        </strong>

        {/* GRID */}
        <Row className="g-4">
          {actions.map((item, i) => (
            <Col xs={6} key={i}>
              <div style={{ textAlign: "center" }}>
                {/* ICON CIRCLE */}
                <div
                  style={{
                    width: "64px",
                    height: "64px",
                    margin: "0 auto 10px",
                    borderRadius: "50%",
                    background: "#1f2933",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={item[1]}
                    alt=""
                    style={{
                      width: "28px",
                      height: "28px",
                      objectFit: "contain",
                    }}
                  />
                </div>

                {/* TEXT */}
                <p
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#4b5563",
                    marginBottom: 0,
                  }}
                >
                  {item[0]}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </Card.Body>

      {/* MOBILE FIX */}
      <style>
        {`
          @media (max-width: 1024px) {
            .card {
              margin-top: 16px;
            }
          }
        `}
      </style>
    </Card>
  );
}